import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Badge,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import {
  getSurveyList,
  createChildFromSurvey,
  sendRemider,
  createPaymentLink,
  createCashPayment,
  createChequePayment,
  refreshPaymentStatus,
  restoreSurvey
} from '../../api/survey';
import moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import SurveyFilterModal from './SurveyFilterModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { validatePermissionKey } from '../../helpers/permission';
import DeleteSurveyModal from './SurveyDeleteModal';

const SurveyListPage = ({ authUser }) => {
  const [breadcrumbItems] = useState([
    { title: 'Surveys', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [surveyList, setSurveyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [publishingId, setPublishingId] = useState(null);
  const [sendingReminderId, setSendingReminderId] = useState(null);
  const [restoringId, setRestoringId] = useState(null);
  const [viewingSurvey, setViewingSurvey] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [linkWarningAlert, setLinkWarningAlert] = useState({
    show: false,
    message: '',
    onConfirm: null
  });
  // Add new state for publish confirmation modal
  const [publishConfirmAlert, setPublishConfirmAlert] = useState({
    show: false,
    surveyId: null,
    surveyName: ''
  });
  // Add new state for restore confirmation modal
  const [restoreConfirmAlert, setRestoreConfirmAlert] = useState({
    show: false,
    surveyId: null,
    surveyName: ''
  });
  const history = useHistory();
  // New state variables for filtering and sorting
  const [dateFilter, setDateFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [statusFilter, setStatusFilter] = useState('');
  const [sortingRule, setSortingRule] = useState('created_at$desc');
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [filterError, setFilterError] = useState(false);
  const [nameFilter, setNameFilter] = useState('');
  const [emailFilter, setEmailFilter] = useState('');
  const [phoneFilter, setPhoneFilter] = useState('');
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    name: '',
    id: null
  });

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedSurveyForPayment, setSelectedSurveyForPayment] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [totalFee, setTotalFee] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [selectedTransactions, setSelectedTransactions] = useState(selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.currentLinkTxnsIndices || []);
  const [creatingLink, setCreatingLink] = useState(false);
  const [isCashPayment, setIsCashPayment] = useState(false);
  const [isChequePayment, setIsChequePayment] = useState(false);
  const [paymentYearFilter, setPaymentYearFilter] = useState('');
  const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
  const [createdByAdminFilter, setCreatedByAdminFilter] = useState('');
  const [discountError, setDiscountError] = useState('');
  const [refreshingStatus, setRefreshingStatus] = useState(false);

  const getErrorMessage = (error) => {
    return (
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong'
    );
  };

  // Badge color mappings
  const paymentStatusColor = {
    paid: 'primary',
    pending: 'danger'
  };

  const linkStatusColor = {
    active: 'primary',
    expired: 'danger',
    cancelled: 'danger',
    paid: 'primary'
  };

  // Initialize from URL parameters
  useEffect(() => {
    if (!authUser) return;

    const params = new URLSearchParams(window.location.search);
    const startDate = params.get('filter_created_start_date');
    const endDate = params.get('filter_created_end_date');
    const name = params.get('filter_name');
    const email = params.get('filter_email');
    const phone = params.get('filter_phone_number');
    const status = params.get('filter_status');

    // Set initial state from URL parameters
    setDateFilter({
      startDate: startDate ? new Date(startDate) : null,
      endDate: endDate ? new Date(endDate) : null
    });
    setNameFilter(name || '');
    setEmailFilter(email || '');
    setPhoneFilter(phone || '');
    setStatusFilter(status || '');

    // Build queryOptions for initial fetch
    const queryOptions = {};
    if (startDate && endDate) {
      queryOptions.filter_created_start_date = startDate;
      queryOptions.filter_created_end_date = endDate;
    }
    if (name) queryOptions.filter_name = name;
    if (email) queryOptions.filter_email = email;
    if (phone) queryOptions.filter_phone_number = phone;
    if (status) queryOptions.filter_status = status;

    updateFilterCount(queryOptions);
    fetchData(1, pagination.pageLimit, queryOptions, sortingRule);
  }, [authUser]);

  // Add useEffect to validate discount when totalFee changes
  useEffect(() => {
    if (discount >= totalFee) {
      setDiscountError('Discount cannot be greater than or equal to total fee');
    } else {
      setDiscountError('');
    }
  }, [totalFee, discount]);

  // Effect to ensure cash and cheque payments are mutually exclusive
  useEffect(() => {
    if (isCashPayment && isChequePayment) {
      setIsChequePayment(false);
    }
  }, [isCashPayment, isChequePayment]);

  const showSuccessAlert = (message) => {
    setAlertMessage(message);
    setSuccessAlert(true);
  };

  const showErrorAlert = (message) => {
    setAlertMessage(message);
    setErrorAlert(true);
  };

  // Updated fetchData function with queryOptions and sortingOption
  const fetchData = async (
    page = 1,
    limit = pagination.pageLimit,
    queryOptions = {
    },
    sortingOption = sortingRule
  ) => {
    setLoading(true);
    try {
      const response = await getSurveyList(
        page,
        limit,
        queryOptions,
        sortingOption
      );
      if (response) {
        setPagination({
          currentPage: response.metadata.page,
          pageLimit: response.metadata.limit,
          totalPages: response.metadata.total_pages,
          totalEntries: response.metadata.total_results
        });
        setSurveyList(response.data);
      }
    } catch (error) {
      console.error('Error fetching surveys:', error);
      showErrorAlert('Failed to load surveys');
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (page) => {
    const queryOptions = createQueryOptions();
    fetchData(page, pagination.pageLimit, queryOptions, sortingRule);
  };

  // Updated handlePublish to show confirmation modal first
  const handlePublish = (surveyId, surveyName) => {
    setPublishConfirmAlert({
      show: true,
      surveyId: surveyId,
      surveyName: surveyName
    });
  };

  // New function to handle confirmed publish
  const handleConfirmPublish = async () => {
    const { surveyId } = publishConfirmAlert;

    try {
      setPublishingId(surveyId);
      setPublishConfirmAlert({ show: false, surveyId: null, surveyName: '' });

      const response = await createChildFromSurvey({ survey_id: surveyId });
      if (response) {
        const queryOptions = createQueryOptions();
        fetchData(
          pagination.currentPage,
          pagination.pageLimit,
          queryOptions,
          sortingRule
        );
        showSuccessAlert('Child created successfully!');
      }
    } catch (error) {
      console.error('Publish error:', error);
      showErrorAlert(getErrorMessage(error));
    } finally {
      setPublishingId(null);
    }
  };

  const handleSendReminder = async (surveyId) => {
    try {
      setSendingReminderId(surveyId);
      const response = await sendRemider({ survey_id: surveyId });
      if (response) {
        showSuccessAlert('Reminder email sent successfully!');
      } else {
        showErrorAlert('Failed to send reminder email.');
      }
    } catch (error) {
      console.error('Send reminder error:', error);
      showErrorAlert(`Error: ${error.message}`);
    } finally {
      setSendingReminderId(null);
    }
  };

  // Updated handleRestoreSurvey to show confirmation modal first
  const handleRestoreSurvey = (surveyId, surveyName) => {
    setRestoreConfirmAlert({
      show: true,
      surveyId: surveyId,
      surveyName: surveyName
    });
  };

  // New function to handle confirmed restore
  const handleConfirmRestore = async () => {
    const { surveyId } = restoreConfirmAlert;

    try {
      setRestoringId(surveyId);
      setRestoreConfirmAlert({ show: false, surveyId: null, surveyName: '' });

      const response = await restoreSurvey(surveyId);
      if (response) {
        showSuccessAlert('Survey restored successfully!');
        // Refresh the data
        const queryOptions = createQueryOptions();
        fetchData(pagination.currentPage, pagination.pageLimit, queryOptions, sortingRule);
      } else {
        showErrorAlert('Failed to restore survey.');
      }
    } catch (error) {
      console.error('Restore error:', error);
      showErrorAlert(`Error: ${error.message}`);
    } finally {
      setRestoringId(null);
    }
  };

  const handleViewDetails = (survey) => {
    setViewingSurvey(survey);
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false);
    setViewingSurvey(null);
  };

  const statusBadge = (status) => {
    switch (status) {
      case 'new':
        return <Badge color="secondary">New</Badge>;
      case 'in-progress':
        return <Badge color="warning">In Progress</Badge>;
      case 'completed':
        return <Badge color="success">Completed</Badge>;
      default:
        return <Badge color="info">Unknown</Badge>;
    }
  };

  const formatDate = (dateString) => {
    return dateString ? moment(dateString).format('MMM D, YYYY') : '--';
  };

  const renderDetailRow = (label, value, size = 12) => (
    <Col md={size}>
      <FormGroup>
        <Label>{label}</Label>
        <Input
          type="text"
          className="form-control"
          defaultValue={value}
          readOnly
        />
      </FormGroup>
    </Col>
  );

  const updateUrlPath = (queryOptions) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(queryOptions)) {
      if (value && value.toString().trim().length > 0) {
        params.append(key, value);
      }
    }
    history.replace({ pathname: '/surveys', search: params.toString() });
  };

  const createQueryOptions = () => {
    const { startDate, endDate } = dateFilter;

    // Always reset filter error
    setFilterError(false);

    const queryOptions = {};

    // Only include dates if both are present
    if (startDate && endDate) {
      queryOptions.filter_created_start_date = new Date(
        startDate
      ).toISOString();
      queryOptions.filter_created_end_date = new Date(endDate).toISOString();
    }

    if (paymentYearFilter && paymentStatusFilter) {
      queryOptions.filter_payment_year = paymentYearFilter;
      queryOptions.filter_payment_status = paymentStatusFilter;
    }

    if (nameFilter) {
      queryOptions.filter_name = nameFilter;
    }
    if (emailFilter) {
      queryOptions.filter_email = emailFilter;
    }

    if (phoneFilter) {
      queryOptions.filter_phone_number = phoneFilter;
    }

    // Only include status if selected
    if (statusFilter) {
      queryOptions.filter_status = statusFilter;
    }

    if (createdByAdminFilter) {
      queryOptions.filter_created_by_admin = createdByAdminFilter;
    }

    updateFilterCount(queryOptions);
    updateUrlPath(queryOptions);
    return queryOptions;
  };

  // Function to count the number of active filters
  const updateFilterCount = (queryOptions) => {
    let count = 0;

    // List of actual filter parameters to count
    const filterKeys = [
      'filter_created_start_date',
      'filter_created_end_date',
      'filter_status',
      'filter_name',
      'filter_email',
      'filter_phone_number',
      'filter_created_by_admin',
    ];

    filterKeys.forEach((key) => {
      if (
        queryOptions[key] !== undefined &&
        queryOptions[key] !== null &&
        queryOptions[key].toString().trim() !== ''
      ) {
        count++;
      }
    });

    setCurrentFilterCount(count);
  };

  // Function to apply filters
  const applyFilters = async () => {
    const queryOptions = createQueryOptions();
    if ((paymentYearFilter && !paymentStatusFilter) ||
      (!paymentYearFilter && paymentStatusFilter)) {
      setFilterError('Payment year and status must be selected together');
      return;
    }
    if (queryOptions) {
      setFilterModalOpen(false);
      await fetchData(1, pagination.pageLimit, queryOptions, sortingRule);
    }
  };

  // Function to reset filters
  const resetFilters = async () => {
    // Reset state first
    setDateFilter({ startDate: null, endDate: null });
    setStatusFilter('');
    setNameFilter('');
    setEmailFilter('');
    setPhoneFilter('');
    setFilterError(false);
    setPaymentYearFilter('');
    setPaymentStatusFilter('');
    setCreatedByAdminFilter('');

    // Create empty query options
    const resetQueryOptions = {
      filter_created_start_date: '',
      filter_created_end_date: '',
      filter_status: '',
      filter_name: '',
      filter_email: '',
      filter_phone_number: ''
    };

    // Immediately update URL and filter count
    updateUrlPath(resetQueryOptions);
    updateFilterCount(resetQueryOptions);

    // Fetch data with reset options
    setFilterModalOpen(false);
    await fetchData(1, pagination.pageLimit, resetQueryOptions, sortingRule);
  };

  // Function to handle sorting option changes
  const fetchSortedList = async (sortingOption) => {
    setSortingRule(sortingOption);
    const queryOptions = createQueryOptions();
    await fetchData(1, pagination.pageLimit, queryOptions, sortingOption);
  };

  const handleDeleteSurvey = async (survey_id, surveyName) => {
    setDeleteModal({ open: true, name: surveyName, id: survey_id });
  };

  const validateInstallmentOrder = () => {
    const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);

    // Check if there are any gaps in selected installments
    if (selectedTransactions.length > 0) {
      const sortedTransactions = [...selectedTransactions].sort((a, b) => a - b);

      // Check if we're starting from the first installment
      if (sortedTransactions[0] !== 0) {
        // Find the first missing installment
        for (let i = 0; i < sortedTransactions[0]; i++) {
          // Check if this installment is already paid
          const isPaid = payment?.txns?.[i]?.isPaid || false;
          if (!isPaid) {
            return {
              isValid: false,
              message: `Please clear installment ${i + 1} first before paying installment ${sortedTransactions[0] + 1}`
            };
          }
        }
      }

      // Check for gaps in the selected installments
      for (let i = 1; i < sortedTransactions.length; i++) {
        if (sortedTransactions[i] !== sortedTransactions[i - 1] + 1) {
          const missingInstallment = sortedTransactions[i - 1] + 1;
          // Check if the missing installment is already paid
          const isPaid = payment?.txns?.[missingInstallment]?.isPaid || false;
          if (!isPaid) {
            return {
              isValid: false,
              message: `You cannot skip installments. Please include installment ${missingInstallment + 1}`
            };
          }
        }
      }
    }

    return { isValid: true, message: '' };
  };

  const handleOpenPaymentModal = (survey) => {
    setSelectedSurveyForPayment(survey);
    setIsCashPayment(false);
    setIsChequePayment(false);
    setDiscountError('');

    if (survey.payments && survey.payments.length > 0) {
      const latestPayment = survey.payments[survey.payments.length - 1];
      setSelectedYear(latestPayment.year);
      setTotalFee(latestPayment.totalfee);
      setDiscount(latestPayment.discount || 0);

      // Pre-select transactions from currentLinkTxnsIndices
      setSelectedTransactions(latestPayment.currentLinkTxnsIndices || []);
    } else {
      setSelectedYear(new Date().getFullYear());
      setTotalFee(0);
      setDiscount(0);
      setSelectedTransactions([]);
    }

    setPaymentModalOpen(true);
  };

  // Function to calculate after discount amount
  const calculateAfterDiscountAmount = () => {
    const selectedAmount = calculateSelectedAmount();
    return Math.max(0, selectedAmount - discount);
  };

  // Function to handle creating payment link
  const handleCreatePaymentLink = async () => {
    if (!selectedSurveyForPayment || selectedTransactions.length === 0) return;

    // Validate discount
    if (discount >= totalFee) {
      setDiscountError('Discount cannot be greater than or equal to total fee');
      return;
    }

    // Validate after discount amount
    const afterDiscountAmount = calculateAfterDiscountAmount();
    if (afterDiscountAmount <= 0) {
      showErrorAlert('After discount amount must be greater than zero');
      return;
    }

    // Validate installment order
    const validation = validateInstallmentOrder();
    if (!validation.isValid) {
      showErrorAlert(validation.message);
      return;
    }

    // Check if there's an active link for this year
    const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);
    if (payment && payment.linkStatus === 'active') {
      setLinkWarningAlert({
        show: true,
        message: 'There is an active payment link for this year. Creating a new link will expire the previous one. Do you want to proceed?',
        onConfirm: () => {
          setLinkWarningAlert({ show: false, message: '', onConfirm: null });
          createPaymentLinkRequest();
        }
      });
      return;
    }

    createPaymentLinkRequest();
  };

  const createPaymentLinkRequest = async () => {
    setCreatingLink(true);
    try {
      const data = {
        survey_id: selectedSurveyForPayment._id,
        year: selectedYear,
        selectedTxns: selectedTransactions,
        totalFee: totalFee,
        discount: discount
      };

      const response = await createPaymentLink(data);
      if (response) {
        showSuccessAlert('Payment link created and sent successfully!');
        setPaymentModalOpen(false);
        setSelectedTransactions([]);

        // Refresh the data
        const queryOptions = createQueryOptions();
        fetchData(pagination.currentPage, pagination.pageLimit, queryOptions, sortingRule);
      } else {
        showErrorAlert('Failed to create payment link.');
      }
    } catch (error) {
      console.error('Error creating payment link:', error);
      showErrorAlert('Error creating payment link. Please try again.');
    } finally {
      setCreatingLink(false);
    }
  };

  // Function to handle cash payment
  const handleCreateCashPayment = async () => {
    if (!selectedSurveyForPayment || selectedTransactions.length === 0) return;

    // Validate discount
    if (discount >= totalFee) {
      setDiscountError('Discount cannot be greater than or equal to total fee');
      return;
    }

    // Validate after discount amount
    const afterDiscountAmount = calculateAfterDiscountAmount();
    if (afterDiscountAmount <= 0) {
      showErrorAlert('After discount amount must be greater than zero');
      return;
    }

    // Validate installment order
    const validation = validateInstallmentOrder();
    if (!validation.isValid) {
      showErrorAlert(validation.message);
      return;
    }

    setCreatingLink(true);
    try {
      const data = {
        survey_id: selectedSurveyForPayment._id,
        year: selectedYear,
        selectedTxns: selectedTransactions,
        totalFee: totalFee,
        discount: discount
      };

      const response = await createCashPayment(data);
      if (response) {
        showSuccessAlert('Cash payment recorded successfully!');
        setPaymentModalOpen(false);
        setIsCashPayment(false);
        setSelectedTransactions([]);
        // Refresh the data
        const queryOptions = createQueryOptions();
        fetchData(pagination.currentPage, pagination.pageLimit, queryOptions, sortingRule);
      } else {
        showErrorAlert('Failed to record cash payment.');
      }
    } catch (error) {
      console.error('Error recording cash payment:', error);
      showErrorAlert('Error recording cash payment. Please try again.');
    } finally {
      setCreatingLink(false);
    }
  };

  // Function to handle cheque payment
  const handleCreateChequePayment = async () => {
    if (!selectedSurveyForPayment || selectedTransactions.length === 0) return;

    // Validate discount
    if (discount >= totalFee) {
      setDiscountError('Discount cannot be greater than or equal to total fee');
      return;
    }

    // Validate after discount amount
    const afterDiscountAmount = calculateAfterDiscountAmount();
    if (afterDiscountAmount <= 0) {
      showErrorAlert('After discount amount must be greater than zero');
      return;
    }

    // Validate installment order
    const validation = validateInstallmentOrder();
    if (!validation.isValid) {
      showErrorAlert(validation.message);
      return;
    }

    setCreatingLink(true);
    try {
      const data = {
        survey_id: selectedSurveyForPayment._id,
        year: selectedYear,
        selectedTxns: selectedTransactions,
        totalFee: totalFee,
        discount: discount
      };

      const response = await createChequePayment(data);
      if (response) {
        showSuccessAlert('Cheque payment recorded successfully!');
        setPaymentModalOpen(false);
        setIsChequePayment(false);
        setSelectedTransactions([]);
        // Refresh the data
        const queryOptions = createQueryOptions();
        fetchData(pagination.currentPage, pagination.pageLimit, queryOptions, sortingRule);
      } else {
        showErrorAlert('Failed to record cheque payment.');
      }
    } catch (error) {
      console.error('Error recording cheque payment:', error);
      showErrorAlert('Error recording cheque payment. Please try again.');
    } finally {
      setCreatingLink(false);
    }
  };

  // Function to toggle transaction selection
  const toggleTransactionSelection = (index) => {
    if (selectedTransactions.includes(index)) {
      setSelectedTransactions(selectedTransactions.filter(i => i !== index));
    } else {
      setSelectedTransactions([...selectedTransactions, index]);
    }
  };

  // Function to calculate total amount for selected transactions
  const calculateSelectedAmount = () => {
    if (!selectedSurveyForPayment) return 0;
    return (totalFee / 4) * selectedTransactions.length;
  };

  const checkPreviousInstallments = (index) => {
    const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);

    if (!payment) {
      // For new payments, check if previous installments are selected
      for (let i = 0; i < index; i++) {
        if (!selectedTransactions.includes(i)) {
          return false;
        }
      }
      return true;
    } else {
      // For existing payments, check if previous installments are paid
      for (let i = 0; i < index; i++) {
        if (!payment.txns?.[i]?.isPaid) {
          return false;
        }
      }
      return true;
    }
  };

  useEffect(() => {
    if (selectedSurveyForPayment) {
      const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);
      if (payment) {
        setTotalFee(payment.totalfee);
        setDiscount(payment.discount || 0);
        // Keep existing selected transactions when changing years
        // Only reset if no payment exists for the new year
      } else {
        setTotalFee(0);
        setDiscount(0);
        setSelectedTransactions([]);
      }
    }
  }, [selectedYear, selectedSurveyForPayment]);

  // Function to handle refresh payment status
  const handleRefreshPaymentStatus = async () => {
    if (!selectedSurveyForPayment) return;

    setRefreshingStatus(true);
    try {
      const data = {
        survey_id: selectedSurveyForPayment._id,
        year: selectedYear
      };

      const response = await refreshPaymentStatus(data);
      if (response) {
        showSuccessAlert('Payment status refreshed successfully!');
        setPaymentModalOpen(false);
        // Refresh the data to get updated status
        const queryOptions = createQueryOptions();
        await fetchData(pagination.currentPage, pagination.pageLimit, queryOptions, sortingRule);

        // Also update the current selected survey data
        const updatedSurvey = await getSurveyList(
          1,
          1,
          { _id: selectedSurveyForPayment._id },
          sortingRule
        );
        if (updatedSurvey && updatedSurvey.data.length > 0) {
          setSelectedSurveyForPayment(updatedSurvey.data[0]);
        }
      } else {
        showErrorAlert('Failed to refresh payment status.');
      }
    } catch (error) {
      console.error('Error refreshing payment status:', error);
      showErrorAlert('Error refreshing payment status. Please try again.');
    } finally {
      setRefreshingStatus(false);
    }
  };

  // Function to check if refresh button should be shown
  const shouldShowRefreshButton = () => {
    if (!selectedSurveyForPayment) return false;

    const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);
    if (!payment) return false;

    // Show refresh button if:
    // 1. Payment is unpaid AND
    // 2. Link exists AND linkStatus is not null/undefined AND not 'paid'
    return (
      payment.paymentStatus !== 'paid' &&
      payment.link &&
      payment.linkStatus &&
      payment.linkStatus !== 'paid'
    );
  };


  return (
    <div className="page-content">
      <SweetAlert
        success
        title="Success!"
        show={successAlert}
        onConfirm={() => setSuccessAlert(false)}
      >
        {alertMessage}
      </SweetAlert>
      <SweetAlert
        error
        title="Error!"
        show={errorAlert}
        onConfirm={() => setErrorAlert(false)}
      >
        {alertMessage}
      </SweetAlert>
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, proceed!"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        title="Warning!"
        onConfirm={linkWarningAlert.onConfirm}
        onCancel={() => setLinkWarningAlert({ show: false, message: '', onConfirm: null })}
        show={linkWarningAlert.show}
      >
        {linkWarningAlert.message}
      </SweetAlert>
      {/* Add the publish confirmation alert */}
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Confirm"
        cancelBtnBsStyle="danger"
        title="Create Child Confirmation"
        onConfirm={handleConfirmPublish}
        onCancel={() => setPublishConfirmAlert({ show: false, surveyId: null, surveyName: '' })}
        show={publishConfirmAlert.show}
      >
        Are you sure you want to create a child record from the survey "{publishConfirmAlert.surveyName}"?
        This action cannot be undone.
      </SweetAlert>
      {/* Add the restore confirmation alert */}
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Confirm"
        cancelBtnBsStyle="danger"
        title="Restore Survey Confirmation"
        onConfirm={handleConfirmRestore}
        onCancel={() => setRestoreConfirmAlert({ show: false, surveyId: null, surveyName: '' })}
        show={restoreConfirmAlert.show}
      >
        Are you sure you want to restore the survey "{restoreConfirmAlert.surveyName}"?
      </SweetAlert>
      <Container fluid>
        <Breadcrumbs title="Surveys" breadcrumbItems={breadcrumbItems} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <Row className="mt-2">
                  <Col md="2">
                    <FormGroup>
                      <Label>Show Entries</Label>
                      <select
                        className="form-control"
                        onChange={(e) => {
                          fetchData(1, e.target.value);
                          setPagination({
                            ...pagination,
                            pageLimit: e.target.value
                          });
                        }}
                        value={pagination.pageLimit}
                        disabled={loading}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <Label>Sort By</Label>
                      <select
                        className="form-control"
                        onChange={(e) => fetchSortedList(e.target.value)}
                        value={sortingRule}
                        disabled={loading}
                      >
                        <option value="created_at$desc">
                          Date Created (Newest First)
                        </option>
                        <option value="created_at$asc">
                          Date Created (Oldest First)
                        </option>
                        <option value="updated_at$desc">
                          Last Updated (Newest First)
                        </option>
                        <option value="updated_at$asc">
                          Last Updated (Oldest First)
                        </option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col className="d-flex justify-content-end align-items-center">
                    <Button
                      size="sm"
                      color="primary"
                      className="mr-3"
                      onClick={() => setFilterModalOpen(true)}
                    >
                      <i className="ri-filter-fill align-middle mr-2"></i>
                      Filter Surveys
                      {currentFilterCount > 0 && (
                        <Badge color="light" pill className="ml-2">
                          {currentFilterCount}
                        </Badge>
                      )}
                    </Button>
                  </Col>
                </Row>
                {loading ? (
                  <div className="text-center">
                    <PageDataLoader />
                  </div>
                ) : (
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <Table striped bordered responsive>
                        <thead>
                          <tr>
                            <th>SL. No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Admission For</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {surveyList.map((survey, index) => (
                            <tr
                              key={survey._id}
                              style={{
                                backgroundColor: survey.hasTerminatedChild ? "#f8d7da" : "",
                              }}
                            >
                              <td >
                                {(pagination.currentPage - 1) *
                                  pagination.pageLimit +
                                  index +
                                  1}
                              </td>
                              <td >
                                {survey?.childId && !survey.hasTerminatedChild ? <Link to={`/children/view/${survey.childId}`}>{survey.name || '--'}</Link> : survey.name || '--'}
                              </td>
                              <td >{survey.email_address || '--'}</td>
                              <td >{survey.phone_number || '--'}</td>
                              <td >{survey.admission_for === '' ? "--" : survey.admission_for}</td>
                              <td>
                                {statusBadge(survey.status)}
                                {survey.isDeleted && (
                                  <Badge color="secondary" className="ml-1">Deleted</Badge>
                                )}
                              </td>
                              <td>
                                <div className="d-flex flex-wrap gap-1" style={{ minWidth: '300px' }}>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    className="text-nowrap m-1"
                                    onClick={() => handleViewDetails(survey)}
                                  >
                                    <i className="fas fa-eye mr-1"></i> View
                                  </Button>

                                  {/* Show different buttons based on isDeleted status */}


                                  <>
                                    <Button
                                      size="sm"
                                      color={
                                        !(
                                          survey.isPublished === true ||
                                          survey.status === 'completed' ||
                                          sendingReminderId === survey._id
                                        )
                                          ? 'warning'
                                          : 'secondary'
                                      }
                                      className="text-nowrap m-1"
                                      onClick={() => handleSendReminder(survey._id)}
                                      disabled={
                                        survey.isPublished === true ||
                                        survey.status === 'completed' ||
                                        sendingReminderId === survey._id ||
                                        survey.isDeleted
                                      }
                                    >
                                      <i className="fas fa-envelope mr-1"></i>
                                      {sendingReminderId === survey._id
                                        ? 'Sending...'
                                        : 'Reminder'}
                                    </Button>

                                    {validatePermissionKey(
                                      authUser,
                                      'publish_survey'
                                    ) && (
                                        <Button
                                          size="sm"
                                          color={
                                            survey.isPublished === true ||
                                              survey.status !== 'completed' || survey?.childExists
                                              ? 'secondary'
                                              : 'success'
                                          }
                                          className="text-nowrap m-1"
                                          onClick={() => handlePublish(survey._id, survey.name)}
                                          disabled={
                                            survey.isPublished === true ||
                                            survey.status !== 'completed' ||
                                            publishingId === survey._id ||
                                            survey?.childExists ||
                                            survey.isDeleted
                                          }
                                        >
                                          <i className="fas fa-upload mr-1"></i>
                                          {publishingId === survey._id
                                            ? 'Publishing...'
                                            : 'Create Child'}
                                        </Button>
                                      )}

                                    {validatePermissionKey(
                                      authUser,
                                      'create_payment_link'
                                    ) && (
                                        <Button
                                          size="sm"
                                          color={survey.status !== 'completed' ? 'secondary' : 'info'}
                                          onClick={() => handleOpenPaymentModal(survey)}
                                          className="text-nowrap m-1"
                                          disabled={
                                            survey.status !== 'completed' ||
                                            survey.isDeleted
                                          }
                                        >
                                          <i className="fas fa-credit-card mr-1"></i> Payment
                                        </Button>
                                      )}
                                    {survey.isDeleted &&
                                      /* Restore Button for deleted surveys */
                                      <Button
                                        size="sm"
                                        color="warning"
                                        className="text-nowrap m-1"
                                        onClick={() => handleRestoreSurvey(survey._id, survey.name)}
                                        disabled={restoringId === survey._id}
                                      >
                                        <i className="fas fa-undo mr-1"></i>
                                        {restoringId === survey._id ? 'Restoring...' : 'Restore'}
                                      </Button>
                                    }

                                    {validatePermissionKey(
                                      authUser,
                                      'delete_survey'
                                    ) && !survey.isDeleted && (
                                        <Button
                                          size="sm"
                                          color={survey?.childExists ? 'secondary' : 'danger'}
                                          onClick={() =>
                                            handleDeleteSurvey(
                                              survey._id,
                                              survey.name
                                            )
                                          }
                                          className="text-nowrap m-1"
                                          disabled={survey?.childExists}
                                        >
                                          <i className="fas fa-trash mr-1"></i>
                                          Delete
                                        </Button>
                                      )}
                                  </>

                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}
                <Row className="mt-2">
                  <Col md="5">
                    <p>
                      <strong>
                        Showing{' '}
                        {(pagination.currentPage - 1) * pagination.pageLimit +
                          1}{' '}
                        to{' '}
                        {Math.min(
                          pagination.currentPage * pagination.pageLimit,
                          pagination.totalEntries
                        )}{' '}
                        of {pagination.totalEntries} entries
                      </strong>
                    </p>
                  </Col>
                  {!loading && surveyList.length > 0 && (
                    <Col md="7" className="d-flex justify-content-end">
                      <Paginator
                        totalPages={pagination.totalPages}
                        currentPage={pagination.currentPage}
                        changePage={handlePagination}
                      />
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={isViewModalOpen} toggle={closeViewModal} size="lg">
          <ModalHeader toggle={closeViewModal}>
            Survey Details: {viewingSurvey?.name || '--'}
            {viewingSurvey?.isDeleted && (
              <Badge color="secondary" className="ml-2">Deleted</Badge>
            )}
          </ModalHeader>
          <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {viewingSurvey ? (
              <Row>
                <Col md="12" className="font-weight-bold h5 pb-2">
                  Child Information
                </Col>

                {renderDetailRow('Full Name', viewingSurvey.name, '4')}
                {renderDetailRow('Email', viewingSurvey.email_address, '4')}
                {renderDetailRow('Emergency Contact', viewingSurvey.emergencyContact || '--', '4')}
                {renderDetailRow(
                  'Phone Number',
                  viewingSurvey.phone_number,
                  '6'
                )}
                {renderDetailRow(
                  'Date Of Birth',
                  formatDate(viewingSurvey.dob),
                  '6'
                )}
                {renderDetailRow('Gender', viewingSurvey.gender, '6')}
                {renderDetailRow(
                  'Address Location',
                  viewingSurvey.address_location,
                  '6'
                )}
                {renderDetailRow(
                  'Year',
                  viewingSurvey?.year || '--',
                  '6'
                )}
                {renderDetailRow(
                  'Admission For',
                  viewingSurvey.admission_for || '--',
                  '6'
                )}
                {renderDetailRow(
                  'Batch Timing',
                  viewingSurvey.batch_timing || '--',
                  '6'
                )}
                {renderDetailRow(
                  'Batch Location',
                  viewingSurvey.batch_location || '--',
                  '6'
                )}
                {renderDetailRow('Address', viewingSurvey.address, '12')}

                <Col md="12" className="font-weight-bold h5 pb-2">
                  Parent Information
                </Col>

                {renderDetailRow('Father Name', viewingSurvey.father_name, '6')}
                {renderDetailRow(
                  'Father Email No.',
                  viewingSurvey.father_email,
                  '6'
                )}
                {renderDetailRow(
                  'Father Phone No.',
                  viewingSurvey.father_phone,
                  '6'
                )}
                {renderDetailRow(
                  'Father Phone No.',
                  formatDate(viewingSurvey.father_dob),
                  '6'
                )}

                {renderDetailRow('Mother Name', viewingSurvey.mother_name, '6')}
                {renderDetailRow(
                  'Mother Email No.',
                  viewingSurvey.mother_email,
                  '6'
                )}
                {renderDetailRow(
                  'Mother Phone No.',
                  viewingSurvey.mother_phone,
                  '6'
                )}
                {renderDetailRow(
                  'Mother Phone No.',
                  formatDate(viewingSurvey.mother_dob),
                  '6'
                )}

                {viewingSurvey.guardian_name && (
                  <>
                    {renderDetailRow(
                      'Guardian Name',
                      viewingSurvey.guardian_name,
                      '6'
                    )}
                    {renderDetailRow(
                      'Guardian Email No.',
                      viewingSurvey.guardian_email,
                      '6'
                    )}
                    {renderDetailRow(
                      'Guardian Phone No.',
                      viewingSurvey.guardian_phone,
                      '6'
                    )}
                    {renderDetailRow(
                      'Guardian Phone No.',
                      formatDate(viewingSurvey.guardian_dob),
                      '6'
                    )}
                  </>
                )}
              </Row>
            ) : (
              <div className="text-center py-4">
                <PageDataLoader />
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={closeViewModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        {/* Filter Modal Component */}
        <SurveyFilterModal
          filterError={filterError}
          modalOpenState={filterModalOpen}
          closeModalHandler={() => setFilterModalOpen(false)}
          dateFilter={dateFilter}
          setDateFilter={setDateFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          applyFilters={applyFilters}
          resetFilters={resetFilters}
          nameFilter={nameFilter}
          setNameFilter={setNameFilter}
          emailFilter={emailFilter}
          setEmailFilter={setEmailFilter}
          phoneFilter={phoneFilter}
          setPhoneFilter={setPhoneFilter}
          paymentYearFilter={paymentYearFilter}
          setPaymentYearFilter={setPaymentYearFilter}
          paymentStatusFilter={paymentStatusFilter}
          setPaymentStatusFilter={setPaymentStatusFilter}
          createdByAdminFilter={createdByAdminFilter}
          setCreatedByAdminFilter={setCreatedByAdminFilter}
        />

        {deleteModal.open && (
          <DeleteSurveyModal
            open={deleteModal.open}
            surveyId={deleteModal.id}
            surveyName={deleteModal.name}
            showSuccessAlert={showSuccessAlert}
            handleClose={() => {
              setDeleteModal({ open: false, name: '', id: null });
            }}
            fetchNewData={() => {
              const queryOptions = createQueryOptions();
              fetchData(
                pagination.currentPage,
                pagination.pageLimit,
                queryOptions,
                sortingRule
              );
            }}
          />
        )}
      </Container>

      <Modal
        isOpen={paymentModalOpen}
        toggle={() => {
          setPaymentModalOpen(false);
          setIsCashPayment(false);
          setIsChequePayment(false);
          if (!paymentModalOpen) setDiscountError('');
        }}
        size="lg"
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <h5 className="mb-0">
            {selectedSurveyForPayment?.name} - Payment Details
          </h5>
          <div className="d-flex gap-2 align-items-center">

            <Button
              size="sm"
              color="info"
              className=" waves-effect waves-light mr-2"
              onClick={() => {
                window.open("https://dashboard.razorpay.com/app/dashboard");
              }}
              style={{ fontSize: "11px" }}
            >
              Razorpay Dashboard
            </Button>

            {selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.paymentStatus && (
              <Badge
                color={paymentStatusColor[selectedSurveyForPayment.payments.find(p => p.year === selectedYear).paymentStatus] || 'warning'}
                className="px-3 py-2 mr-2"
                style={{ fontSize: "11px" }}
              >
                Payment Status: {selectedSurveyForPayment.payments.find(p => p.year === selectedYear).paymentStatus}
              </Badge>
            )}

            {/* Refresh Status Button */}
            {shouldShowRefreshButton() && (
              <Button
                color="warning"
                size="sm"
                onClick={handleRefreshPaymentStatus}
                disabled={refreshingStatus}
                style={{ fontSize: "11px" }}
              >
                <i className={`fas ${refreshingStatus ? 'fa-spin fa-spinner' : 'fa-sync-alt'} mr-1`}></i>
                {refreshingStatus ? 'Refreshing...' : 'Refresh Status'}
              </Button>
            )}
          </div>
        </div>

        <ModalBody>
          {selectedSurveyForPayment && (
            <div className="d-flex flex-column gap-4">

              {/* Section 1: Year Selection */}
              <div className="border rounded p-3">
                <h6 className="mb-3 text-muted">Select Year</h6>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Academic Year</Label>
                      <Input
                        type="select"
                        value={selectedYear}
                        onChange={(e) => {
                          const newYear = e.target.value === "other" ? "other" : parseInt(e.target.value);
                          setSelectedYear(newYear);

                          if (newYear !== "other") {
                            const payment = selectedSurveyForPayment.payments?.find(p => p.year === newYear);
                            if (payment) {
                              setTotalFee(payment.totalfee);
                              setDiscount(payment.discount || 0);
                              // Auto-select paid installments
                              if (payment.paymentStatus === 'paid' && payment.currentLinkTxnsIndices) {
                                setSelectedTransactions(payment.currentLinkTxnsIndices);
                              } else {
                                setSelectedTransactions([]);
                              }
                            } else {
                              setTotalFee(0);
                              setDiscount(0);
                              setSelectedTransactions([]);
                            }
                          }
                        }}
                      >
                        {Array.from({ length: 6 }, (_, i) => {
                          const year = new Date().getFullYear() + i;
                          return (
                            <option key={year} value={year}>
                              {year} - {year + 1}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label>Total Fee</Label>
                      <Input
                        type="number"
                        value={totalFee}
                        onChange={(e) => {
                          const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);
                          if (!payment || payment.paymentStatus !== 'paid') {
                            setTotalFee(parseFloat(e.target.value));
                          }
                        }}
                        readOnly={!!selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid'}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* Section 3: Installments */}
              <div className="border rounded p-3">
                <h6 className="mb-3 text-muted">Installments</h6>
                <table className="table table-bordered table-sm">
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: "12%" }}>Select</th>
                      <th style={{ width: "25%" }}>Installment</th>
                      <th style={{ width: "20%" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[0, 1, 2, 3].map(index => {
                      const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);
                      const isPaid = payment?.txns?.[index]?.isPaid || false;
                      const isCurrentLinked = payment?.currentLinkTxnsIndices?.includes(index) || false;

                      // Auto-select if payment is paid and this installment is in currentLinkTxnsIndices
                      const shouldBeChecked = payment?.paymentStatus === 'paid' ? isCurrentLinked : selectedTransactions.includes(index);
                      const shouldBeDisabled = payment?.paymentStatus === 'paid' || isPaid;

                      return (
                        <tr key={index}>
                          <td className="text-center">
                            <Input
                              type="checkbox"
                              checked={shouldBeChecked}
                              onChange={() => !shouldBeDisabled && toggleTransactionSelection(index)}
                              disabled={shouldBeDisabled}
                            />
                          </td>
                          <td>Installment {index + 1}</td>
                          <td>₹{(totalFee) / 4}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {/* Payment Note */}
                {selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid' && (
                  <div className="mt-2">
                    <small style={{ color: 'red' }}>
                      Checked installments are taken as the admission fee. Any other payment will be done via transactions
                    </small>
                  </div>
                )}
              </div>

              {/* Section 4: Totals & Payment Method */}
              <div className="border rounded p-3">
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Total Amount</Label>
                      <Input type="text" value={`₹${selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === "paid"
                        ? selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paidAmount + Number(selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.discount) || 0
                        : calculateSelectedAmount()
                        }`} readOnly />
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>Discount</Label>
                      <Input
                        type="number"
                        value={discount}
                        onChange={(e) => {
                          const payment = selectedSurveyForPayment.payments?.find(p => p.year === selectedYear);
                          if (!payment || payment.paymentStatus !== 'paid') {
                            setDiscount(parseFloat(e.target.value));
                          }
                        }}
                        readOnly={!!selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid'}
                        invalid={!!discountError}
                      />
                      {discountError && <div className="invalid-feedback d-block">{discountError}</div>}
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup>
                      <Label>{selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === "paid" ? "Amount Paid" : "After Discount"}</Label>
                      <Input
                        type="text"
                        value={`₹${selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === "paid" ? selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paidAmount || 0 : calculateAfterDiscountAmount()}`}
                        readOnly
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <Row>
                      {validatePermissionKey(
                        authUser,
                        'create_cash_payment'
                      ) && (
                          <Col md={4} className="d-flex align-items-center">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={isCashPayment || selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentMethod === 'cash'}
                                  onChange={() => {
                                    if (selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus !== 'paid') {
                                      setIsCashPayment(!isCashPayment);
                                      if (!isCashPayment) setIsChequePayment(false);
                                    }
                                  }}
                                  disabled={selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid'}
                                />{" "}
                                Cash Payment
                                {selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentMethod === 'cash' &&
                                  selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid' &&
                                  " (Paid)"
                                }
                              </Label>
                            </FormGroup>
                          </Col>
                        )}

                      {validatePermissionKey(
                        authUser,
                        'create_cheque_payment'
                      ) && (
                          <Col md={4} className="d-flex align-items-center">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={isChequePayment || selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentMethod === 'cheque'}
                                  onChange={() => {
                                    if (selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus !== 'paid') {
                                      setIsChequePayment(!isChequePayment);
                                      if (!isChequePayment) setIsCashPayment(false);
                                    }
                                  }}
                                  disabled={selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid'}
                                />{" "}
                                Cheque Payment
                                {selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentMethod === 'cheque' &&
                                  selectedSurveyForPayment.payments?.find(p => p.year === selectedYear)?.paymentStatus === 'paid' &&
                                  " (Paid)"
                                }
                              </Label>
                            </FormGroup>
                          </Col>
                        )}
                    </Row>
                  </Col>
                </Row>
                {selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.failureReason && <Row className="mt-2 p-3">
                  <p style={{ color: "red" }}>Reason for failure: {selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.failureReason}</p>
                </Row>}
              </div>
            </div>
          )}
        </ModalBody>

        {/* Footer */}
        <div className="d-flex justify-content-between align-items-center p-3 border-top">
          {selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.linkStatus ? (
            <Badge
              color={linkStatusColor[selectedSurveyForPayment.payments.find(p => p.year === selectedYear).linkStatus] || 'info'}
              className="px-3 py-2"
              style={{ fontSize: "0.8rem" }}
            >
              Link Status: {selectedSurveyForPayment.payments.find(p => p.year === selectedYear).linkStatus}
            </Badge>
          )
            : <div></div>
          }

          <div>
            <Button
              className="mr-2"
              size="sm"
              color="secondary"
              onClick={() => {
                setPaymentModalOpen(false);
                setIsCashPayment(false);
                setIsChequePayment(false);
              }}
            >
              Cancel
            </Button>

            {/* Disable payment buttons if payment is already paid */}
            {selectedSurveyForPayment?.payments?.find(p => p.year === selectedYear)?.paymentStatus !== 'paid' && (
              <>
                {isCashPayment ? (
                  <Button
                    color="success"
                    size="sm"
                    onClick={handleCreateCashPayment}
                    disabled={selectedTransactions.length === 0 || creatingLink || !!discountError || calculateAfterDiscountAmount() <= 0}
                  >
                    {creatingLink ? "Processing..." : "Record Cash Payment"}
                  </Button>
                ) : isChequePayment ? (
                  <Button
                    color="info"
                    size="sm"
                    onClick={handleCreateChequePayment}
                    disabled={selectedTransactions.length === 0 || creatingLink || !!discountError || calculateAfterDiscountAmount() <= 0}
                  >
                    {creatingLink ? "Processing..." : "Record Cheque Payment"}
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    size="sm"
                    onClick={handleCreatePaymentLink}
                    disabled={selectedTransactions.length === 0 || creatingLink || !!discountError || calculateAfterDiscountAmount() <= 0}
                  >
                    {creatingLink ? "Creating Link..." : "Create Payment Link"}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUser: state.Login.user
});

export default connect(mapStateToProps)(SurveyListPage);